import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const scopeEnum = z.enum(['global', 'tenant', 'user']);

const testResolveRequestSchema = z.object({
  tenantId: z.string().uuid(),
  userId: z.string().uuid().optional(),
  llmOutputType: z.string(),
  specialty: z.string().optional(),
  language: z.string().optional(),
});

export const testResolveResponseSchema = z.object({
  resolved: z
    .object({
      promptTemplateId: z.string().uuid(),
      promptTemplateName: z.string(),
      customInstructions: z.string().nullable(),
      scope: scopeEnum,
    })
    .nullable(),
  allDefaults: z.array(
    z.object({
      id: z.string().uuid(),
      scope: scopeEnum,
      specialty: z.string().nullable(),
      language: z.string().nullable(),
      promptTemplateId: z.string().uuid(),
      promptTemplateName: z.string(),
      customInstructions: z.string().nullable(),
    }),
  ),
  context: z.object({
    tenantName: z.string(),
    userName: z.string().nullable(),
    userEmail: z.string().nullable(),
    userSpecialty: z.string().nullable(),
    effectiveSpecialty: z.string().nullable(),
  }),
});

export const adminPromptTemplateDefaultsContract = c.router(
  {
    testResolve: {
      method: 'POST',
      path: '/test-resolve',
      responses: {
        200: testResolveResponseSchema,
      },
      body: testResolveRequestSchema,
      summary:
        'Test prompt template default resolution for a specific tenant, user, and parameters',
    },
  },
  {
    pathPrefix: '/admin/prompt-template-defaults',
  },
);
